import Icon from "../assets/icons/icon";
import { constructMotorAtlasLink, printReadableECode } from "../utilities/stringExtraFunctions";

type Props = {
  motorAtlasId: string | null | undefined,
  motorAtlasTab?: "teknisk" | "nypris" | "udstyr",
  firstRegDate?: string | null,
  isVan?: boolean;
}
export default function MotorAtlasLink({ motorAtlasId, motorAtlasTab = "nypris", firstRegDate, isVan }: Props) {
  const link = constructMotorAtlasLink(motorAtlasId ?? "", motorAtlasTab, firstRegDate, isVan)
  return (
    <a className="tag-link d-inline-block" target="_blank" href={link}>
      {printReadableECode(motorAtlasId || '')}
      <Icon className="ml-03" name="open-outline" />
    </a>
  )
}

